// extracted by mini-css-extract-plugin
module.exports = {"authors":"card-authors_authors__1qnzU"};